<template>
  <section>
    <v-container fluid grid-list-md>
      <page-title :title="$t('iscritti.cta4')" />
      <v-select label="Seleziona utente" v-model="sub" :items="subscribers" item-value="id" @change="changeData">
        <template slot="selection" slot-scope="data">
          <!-- HTML that describe how select should render selected items -->
          {{ data.item.name }} {{ data.item.surname }}
        </template>
        <template slot="item" slot-scope="data">
          <!-- HTML that describe how select should render items when the select is open -->
          {{ data.item.name }} {{ data.item.surname }}
        </template>
      </v-select>
    </v-container>
    <v-container fluid v-if="sub != null">
      <v-layout row wrap>
        <v-flex xs12>
          <v-list three-line>
            <div class="pa-4">
              <h3>Dati utente:</h3>
              <br />
              <v-form>
                <v-text-field v-model="subName" label="Nome:" outlined required></v-text-field>
                <v-text-field
                  v-model="subSurname"
                  label="Cognome:"
                  outlined
                  required
                ></v-text-field>
                <v-text-field
                  v-model="subEmail"
                  label="Email Istituzionale:"
                  outlined
                  required
                ></v-text-field>
                <v-text-field v-model="subGmail" label="Email Google:" outlined></v-text-field>
                <v-text-field v-model="subTag" label="Tag:" outlined required></v-text-field>
                <v-text-field v-model="subLang" label="Lingua:" outlined required></v-text-field>
                <v-checkbox label="Mostra opzioni avanzate" v-model="checkValue"></v-checkbox>
                <div v-if="checkValue">
                  <v-container class="d-flex">
                    <v-text-field
                      v-model="subId"
                      label="Id:"
                      outlined
                      required
                      :disabled="!enableId"
                    ></v-text-field>
                    <v-checkbox label="Abilita modifica" v-model="enableId"></v-checkbox>
                  </v-container>
                  <v-container class="d-flex">
                    <v-text-field
                      v-model="subToken"
                      label="Access Token:"
                      outlined
                      required
                      :disabled="!enableToken"
                    ></v-text-field>
                    <v-checkbox label="Abilita modifica" v-model="enableToken"></v-checkbox>
                  </v-container>
                </div>
                <v-btn color="primary" @click="sendEdit">Modifica</v-btn>
              </v-form>
            </div>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { $EventBus } from '@/eventBus';
import _union from 'lodash/union';
import PageTitle from '../common/PageTitle.vue';
import _ from 'lodash';

export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      sub: null,
      subscribers: [],
      limit: 18,
      page: 1,
      q: null,
      checkValue: false,
      enableId: false,
      enableToken: false,
      subName: null,
      subSurname: null,
      subEmail: null,
      subGmail: null,
      subTag: null,
      subLang: null,
      subId: null,
      subToken: null,
    };
  },
  methods: {
    changeData() {
      this.subName = this.getElement('name');
      this.subSurname = this.getElement('surname');
      this.subEmail = this.getElement('email');
      this.subGmail = this.getElement('google_mail');
      this.subTag = this.getElement('tag');
      this.subLang = this.getElement('lang');
      this.subId = this.getElement('id');
      this.subToken = this.getElement('access_token');
    },
    sendEdit() {
      // Logica di invio delle modifiche a datahub...
      this.$http({
        method: 'post',
        url: '/datahub/getintouch/edit',
        data: {
          id: this.subId,
          name: this.subName,
          surname: this.subSurname,
          lang: this.subLang,
          access_token: this.subToken,
          email: this.subEmail,
          gmail: this.subGmail,
          tag: this.subTag,
        },
      })
        .then((response) => {
          this.subscribers = response.data.data;
          $EventBus.$emit('message', { type: 'success', text: 'Utente modificato con successo!' });
          this.$router.push("/getintouch");
        })
        .catch((err) => {
          console.log('lista get error', err);
          $EventBus.$emit('message', { type: 'error', text: 'Impossibile modificare l\'utente' });
        });
    },
    getElement(type) {
      let value = '';
      for (const el of this.subscribers) {
        if (el.id === this.sub) {
          value = el[type];
        }
      }
      return value;
    },
    fetchSubscribers() {
      this.$http({
        method: 'get',
        url: '/datahub/getintouch/all',
      })
        .then((response) => {
          this.subscribers = response.data;
          this.subName = this.getElement('name');
          this.subSurname = this.getElement('surname');
          this.subEmail = this.getElement('email');
          this.subGmail = this.getElement('google_mail');
          this.subTag = this.getElement('tag');
          this.subLang = this.getElement('lang');
          this.subId = this.getElement('id');
          this.subToken = this.getElement('access_token');
        })
        .catch((err) => {
          console.log('lista get error', err);
          $EventBus.$emit('message', { type: 'error', text: 'Impossibile recuperare lista' });
        });
    },
  },
  mounted() {
    this.fetchSubscribers();
    this.sub = this.$route.params.id;
  },
};
</script>
